
















































































import Vue from 'vue';
import {
  HubCard,
  HubHeading,
  HubIcon,
} from './HubComponents';

export default Vue.extend({
  name: 'AppHeaderGallery',
  components: {
    HubCard,
    HubHeading,
    HubIcon,
  },
  props: {
    lg: {
      type: Boolean,
      default: false,
    },
    buttons: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    title: {
      type: String,
      required: false,
    },
    breadcrumb: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
  },
});
